import { ReactKeycloakProvider } from "@react-keycloak/web";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { keycloak, keycloakInitOptions } from "./Authentication/keycloak";
import { UserProvider } from "./context/user.context";
import "./i18n";
import "./index.scss";
import { BrowserRouter } from "react-router-dom";
import { UserValidationProvider } from "./context/user-validating.context";

const eventLogger = (event, error) => {
  console.log("onKeycloakEvent", event, error);
};

const tokenLogger = (tokens) => {
  console.log("onKeycloakTokens", tokens);
};

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

//console.log("ENV", process.env)
console.log("REACT_APP_KEYCLOAK_URL:", process.env.REACT_APP_KEYCLOAK_URL);
console.log("REACT_APP_KEYCLOAK_REALM:", process.env.REACT_APP_KEYCLOAK_REALM);
console.log("REACT_APP_KEYCLOAK_CLIENT_ID:", process.env.REACT_APP_KEYCLOAK_CLIENT_ID);
console.log("REACT_APP_BACKEND_URL:", process.env.REACT_APP_BACKEND_URL);
console.log("REACT_APP_API_ENDPOINT:", process.env.REACT_APP_API_ENDPOINT);
console.log("REACT_APP_NAME:", process.env.REACT_APP_NAME);
console.log("REACT_APP_VERSION:", process.env.REACT_APP_VERSION);
console.log("REACT_CURRENCY:", process.env.REACT_APP_VERSION);
console.log("REACT_APP_VENDING_FILTER_MODE:", process.env.REACT_APP_VENDING_FILTER_MODE);
console.log("REACT_APP_TRANSACTION_FILTER_MODE:", process.env.REACT_APP_TRANSACTION_FILTER_MODE);

root.render(
  /*<ReactKeycloakProvider
    initOptions={keycloakInitOptions}
    authClient={keycloak}
    onEvent={eventLogger}
    onTokens={tokenLogger}
  >
    <DashboardApp />
  </ReactKeycloakProvider>*/

  <ReactKeycloakProvider initOptions={keycloakInitOptions} authClient={keycloak} onEvent={eventLogger} onTokens={tokenLogger}>
    <UserValidationProvider>
      <UserProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </UserProvider>
    </UserValidationProvider>
  </ReactKeycloakProvider>
);
//<AppRouter />
